import actionTypes from "../actionTypes";

const permissions = (state = [], action) => {
  switch (action.type) {
    case actionTypes.PERMISSIONS_FETCH:
      return action.payload.data;
    case actionTypes.PERMISSION_POST:
      return [...state, action.payload.data];
    case actionTypes.PERMISSION_DELETE:
      return state.filter(
        permission => permission.id !== action.payload.permission.id
      );
    default:
      return state;
  }
};

export default permissions;



// WEBPACK FOOTER //
// ./src/redux/reducers/Permissions.js